import { Navigate } from "react-router-dom";
import { DASHBOARD_PATH } from "../constants/AppConstants";

const Navigation = {
  navigateToLogin(from) {
    return (
      <Navigate
        to={`/${DASHBOARD_PATH.ROOT}/${DASHBOARD_PATH.LANDING}`}
        state={from ? { from } : undefined}
        replace
      />
    );
  },
  navigateToHome() {
    return (
      <Navigate to={`/${DASHBOARD_PATH.ROOT}/${DASHBOARD_PATH.MENU}`} />
    );
  },
};

export default Navigation;
